import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function AdminSettings() {
  const [settings, setSettings] = useState({
    app_name: "",
    support_email: "",
    support_phone: "",
    default_language: "en",
    timezone: "Asia/Kolkata",
    maintenance_mode: "false",
    farmer_registration_enabled: "true",

    weather_api_key: "",
    ai_recommendations_enabled: "true",
    photo_upload_enabled: "true",
    checklist_reminders_enabled: "true",
    planner_reminders_enabled: "true",
    support_module_enabled: "true",
    max_photo_upload_size_mb: "10",

    email_notifications_enabled: "true",
    sms_notifications_enabled: "false",
    support_ticket_alerts: "true",
    overdue_planner_alerts: "true",
    missed_checklist_alerts: "true",

    session_timeout_minutes: "60"
  });

  const [passwordForm, setPasswordForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: ""
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await AdminAPI.get("/settings");
      setSettings((prev) => ({
        ...prev,
        ...res.data
      }));
    } catch (err) {
      console.log(err);
      toast.error("Failed to load settings");
    }
  };

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value
    });
  };

  const handlePasswordChange = (e) => {
    setPasswordForm({
      ...passwordForm,
      [e.target.name]: e.target.value
    });
  };

  const saveSettings = async () => {
    try {
      await AdminAPI.put("/settings", settings);
      toast.success("Settings updated successfully");
    } catch (err) {
      console.log(err);
      toast.error("Failed to update settings");
    }
  };

  const changePassword = async () => {
    if (
      passwordForm.new_password !==
      passwordForm.confirm_password
    ) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await AdminAPI.put(
        "/settings/change-password",
        {
          current_password:
            passwordForm.current_password,
          new_password:
            passwordForm.new_password
        }
      );

      toast.success("Password changed successfully");

      setPasswordForm({
        current_password: "",
        new_password: "",
        confirm_password: ""
      });

    } catch (err) {
      console.log(err);
      toast.error(
        err.response?.data?.message ||
        "Password change failed"
      );
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        <h2 className="mt-3">⚙️ Settings</h2>

        {/* Platform Settings */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Platform Settings</h4>

            <div className="row g-3 mt-2">
              <div className="col-md-4">
                <label>App Name</label>
                <input
                  name="app_name"
                  className="form-control"
                  value={settings.app_name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label>Support Email</label>
                <input
                  name="support_email"
                  className="form-control"
                  value={settings.support_email}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label>Support Phone</label>
                <input
                  name="support_phone"
                  className="form-control"
                  value={settings.support_phone}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label>Language</label>
                <select
                  name="default_language"
                  className="form-select"
                  value={settings.default_language}
                  onChange={handleChange}
                >
                  <option value="en">English</option>
                  <option value="mr">Marathi</option>
                  <option value="hi">Hindi</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>Timezone</label>
                <input
                  name="timezone"
                  className="form-control"
                  value={settings.timezone}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label>Maintenance Mode</label>
                <select
                  name="maintenance_mode"
                  className="form-select"
                  value={settings.maintenance_mode}
                  onChange={handleChange}
                >
                  <option value="false">Disabled</option>
                  <option value="true">Enabled</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>Farmer Registration</label>
                <select
                  name="farmer_registration_enabled"
                  className="form-select"
                  value={settings.farmer_registration_enabled}
                  onChange={handleChange}
                >
                  <option value="true">Enabled</option>
                  <option value="false">Disabled</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Settings */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Feature Settings</h4>

            <div className="row g-3 mt-2">
              <div className="col-md-6">
                <label>Weather API Key</label>
                <input
                  name="weather_api_key"
                  className="form-control"
                  value={settings.weather_api_key}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3">
                <label>Max Photo Upload (MB)</label>
                <input
                  name="max_photo_upload_size_mb"
                  className="form-control"
                  value={settings.max_photo_upload_size_mb}
                  onChange={handleChange}
                />
              </div>

              {[
                "ai_recommendations_enabled",
                "photo_upload_enabled",
                "checklist_reminders_enabled",
                "planner_reminders_enabled",
                "support_module_enabled",
                "email_notifications_enabled",
                "sms_notifications_enabled",
                "support_ticket_alerts",
                "overdue_planner_alerts",
                "missed_checklist_alerts"
              ].map((key) => (
                <div className="col-md-4" key={key}>
                  <label>{key}</label>
                  <select
                    name={key}
                    className="form-select"
                    value={settings[key]}
                    onChange={handleChange}
                  >
                    <option value="true">Enabled</option>
                    <option value="false">Disabled</option>
                  </select>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Security */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Security</h4>

            <div className="row g-3 mt-2">
              <div className="col-md-3">
                <label>Session Timeout (minutes)</label>
                <input
                  name="session_timeout_minutes"
                  className="form-control"
                  value={settings.session_timeout_minutes}
                  onChange={handleChange}
                />
              </div>
            </div>

            <hr />

            <h5>Change Password</h5>

            <div className="row g-3">
              <div className="col-md-4">
                <input
                  type="password"
                  name="current_password"
                  className="form-control"
                  placeholder="Current Password"
                  value={passwordForm.current_password}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  type="password"
                  name="new_password"
                  className="form-control"
                  placeholder="New Password"
                  value={passwordForm.new_password}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="col-md-4">
                <input
                  type="password"
                  name="confirm_password"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={passwordForm.confirm_password}
                  onChange={handlePasswordChange}
                />
              </div>
            </div>

            <button
              className="btn btn-warning mt-3"
              onClick={changePassword}
            >
              Change Password
            </button>
          </div>
        </div>

        <button
          className="btn btn-success mt-4"
          onClick={saveSettings}
        >
          Save All Settings
        </button>
      </div>
    </div>
  );
}

export default AdminSettings;